import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppConfigService {

    private config: any;
    private loadPromise: Promise<any> | null = null;

    constructor(private http: HttpClient) { }

    load(): Promise<any> {
        if (!this.loadPromise) {
            this.loadPromise = this.http.get('/assets/config/app.config.json')
                .toPromise()
                .then(data => this.config = data);
        }
        return this.loadPromise;
    }

    getServerAddress() {
        if (!this.config) {
            throw Error('Config file not loaded!');
        }

        return this.config.serverAddress;
    }

    getGoogleMapsApiKey(): string {
        if (!this.config) {
            throw Error('Config file not loaded!');
        }

        return this.config.googleMapsApiKey;
    }
}
